<template>
    <div>
        Groups
    </div>
</template>

<script>
    export default {
        name: 'GroupsView',

        setup() {

        }
    }
</script>

<style lang="scss" scoped>

</style>